import Carousel from 'react-bootstrap/Carousel';
import './slider.css'



function UncontrolledExample() {

    return (
        <Carousel>
            <Carousel.Item>
                <img
                    className="d-block w-100 "
                    src="https://w.forfun.com/fetch/4d/4d3504bf1d386018e609354cf432e81e.jpeg?w=1470&r=0.5625"

                    alt="First slide"
                />
                <Carousel.Caption style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                    <h3 >Місто в якому нема лиш мене</h3>
                    <p>На нашому сайті ви можете насолодитись переглядом цього чудового аніме</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src='https://w.forfun.com/fetch/8b/8bef8c814a74ecdd62cdf9c58c37ba53.jpeg?w=1470&r=0.5625'
                    alt="Second slide"
                />

                <Carousel.Caption style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                    <h3>Місто в якому нема лиш мене</h3>
                    <p>Бажаємо вам примного перегляду</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100 "
                    src="https://w.forfun.com/fetch/e2/e20e5dc134160008494d52a634ffa4dc.jpeg?w=1470&r=0.5625"
                    alt="Third slide"
                />

                <Carousel.Caption style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                    <h3>Місто в якому нема лиш мене</h3>
                    <p>
                       Якщо хочете підтримати автора сайту, то ви можете знайти його контакти в самому низу сайту і висловити йому свої подяки
                    </p>
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    );
}

export default UncontrolledExample;